<template>
    <div>
        <template v-if="finance_ledger_report === true">
            <div>
                <div class="corporate-main">
                    <h1>VR Corporate Ledger</h1>
                    <br>
                    <div class="row">
                        <div class="col-md-3">
                            <div class="form-group" :class="{ 'calendar-error': form.errors.has('from_date') }">
                                <label class="label block-label"> From Date </label>
                                <datepicker name="from_date" input-class="datepicker" :bootstrap-styling="true" v-model="form.from_date" :input-class="{ 'is-invalid': form.errors.has('from_date') }"  placeholder="From Date"></datepicker>
                                <has-error :form="form" field="from_date"></has-error>
                            </div>
                        </div>
                        <div class="col-md-3">
                            <div class="form-group" :class="{ 'calendar-error': form.errors.has('to_date') }">
                                <label class="label block-label"> To Date </label>
                                <datepicker name="to_date" v-model="form.to_date" input-class="datepicker" :input-class="{ 'is-invalid': form.errors.has('to_date') }"  :bootstrap-styling="true" placeholder="To Date"></datepicker>
                                <has-error :form="form" field="to_date"></has-error>
                            </div>
                        </div>
                        <div class="col-md-3" v-if="companies.length>1">
                            <div class="form-group">
                                <label class="label block-label"> Companies </label>
                                <select v-model="form.company_id" name="company_id" data-live-search="true" class="form-control selectpicker custom-select2" v-if="companies != null" :class="{ 'is-invalid': form.errors.has('company_id') }">
                                    <option value="All">All</option>
                                    <option v-for="company in companies" v-bind:value="company.id" v-bind:key="company.id">
                                        {{ company.name }}
                                    </option>
                                </select>
                                <has-error :form="form" field="company_id"></has-error>
                            </div>
                        </div>
                        <div class="col-md-3">
                            <div class="form-group">
                                <label class="label block-label"> Type </label>
                                <select v-model="form.type" name="type" class="form-control selectpicker custom-select2" >
                                    <option value="" selected>Select Type</option>
                                    <option value="">All</option>
                                    <option value="CREDIT">CREDIT</option>
                                    <option value="DEBIT">DEBIT</option>
                                </select>
                            </div>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-md-3">
                            <div class="form-group">
                                <label> Transaction Type</label>
                                <select v-model="form.transaction_type" name="transaction_type" class="form-control" >
                                    <option value="" selected>Select Transaction Type</option>
                                    <option value="IBFT">IBFT</option>
                                    <option value="LFT">LFT</option>
                                </select>
                            </div>
                        </div>
                        <div class="col-md-3">
                            <div class="form-group">
                                <label> Payment Type</label>
                                <select v-model="form.payment_type" name="payment_type" class="form-control" >
                                    <option value="" selected>Select Payment Type</option>
                                    <option value="payroll">Payroll</option>
                                    <option value="vendor">Vendor</option>
                                    <option value="bill">Bill</option>
                                    <option value="topUp">TopUp</option>
                                    <option value="VAtopUp">VA TopUp</option>
                                    <option value="subscriptionFee">Subscription Fee</option>
                                    <option value="integrationFee">Integration Fee</option>
                                    <option value="collectionFee">Collection Fee</option>
                                    <option value="collectionSettlement">Collection Settlement</option>
                                    <option value="expense">Expense</option>
                                </select>
                            </div>
                        </div>
                        <div class="col-md-3">
                            <div class="form-group">
                                <label> Adjustment</label>
                                <select v-model="form.adjustment" name="adjustment" class="form-control" >
                                    <option value="" selected>Select Adjustment</option>
                                    <option value="YES">YES</option>
                                    <option value="NO">NO</option>
                                </select>
                            </div>
                        </div>
                        <div class="col-md-3">
                            <div class="form-group">
                                <br>
                                <button @click="downloadData" class="btn btn-primary">Export</button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </template>
        <template v-else-if="finance_ledger_report === null">
            <preLoader></preLoader>
        </template>
        <template v-else-if="finance_ledger_report === false">
            <notAllowed></notAllowed>
        </template>
    </div>
</template>

<script>
    // var dtTable = null;
    export default {
        data() {
            return {
                ledger : [],
                account_balance: null,
                showBtn: false,
                finance_ledger_report: null,
                companies:[],
                check:'',
                dtTable:'',
                form: new Form({
                    company_id: 'All',
                    from_date : '',
                    to_date : '',
                    type : '',
                    responseType: 'blob',
                    transaction_type:'',
                    payment_type:'',
                    adjustment:'',
                }),
            };
        },
        methods: {
            getCompanies(){
                let self=this;
                axios.get('/api/getCompaniesLeadger')
                .then((response) => {
                    self.companies=response.data.companies;
                    self.check=response.data.check;
                    setTimeout(function(){  $("#company_id").selectpicker('refresh'); }, 0);
                }).catch(err => {
                    this.$Progress.fail();
                    this.showAlertBox('error','There is some problem');
                });
            },
            downloadData() {
                let that = this;
                this.$Progress.start();
                this.form.from_date = moment(this.form.from_date).format('YYYY-MM-DD');
                this.form.to_date = moment(this.form.to_date).format('YYYY-MM-DD');
                this.form.post('/api/downloadVRCorpData').then(res => {
                    if(res.status == 200){
                        const url = URL.createObjectURL(new Blob([res.data], {
                            type: 'application/vnd.ms-excel'
                        }))
                        const link = document.createElement('a')
                        link.href = url
                        link.setAttribute('download', 'vrCorporateLedger.csv')
                        document.body.appendChild(link)
                        link.click()
                        toast.fire({
                            type: 'success',
                            title: 'Downloaded successfully'
                        });
                        this.$Progress.finish();
                    }else{
                        $(that.$el).find('.selectpicker').selectpicker('refresh');
                        this.$Progress.fail();
                    }
                })
                .catch(err => {
                    var exception_string = '';
                    if(typeof(err.response.data.errors) != "undefined" && err.response.data.errors !== null) {
                        exception_string += '<ul><li><b>Error</b></li>';
                        var error_messages = err.response.data.errors;
                        jQuery.each(error_messages, function(index, item) {
                            exception_string += '<li>'+item[0]+'</li>';
                        });
                    } else {
                        exception_string += 'Some problem in your form data';
                    }
                    $(that.$el).find('.selectpicker').selectpicker('refresh');
                    this.$Progress.fail();
                    this.showAlertBox('error',exception_string);
                });
            },
        },
        mounted() {
            $(document).ready(function(){
                $('#company_id').selectpicker();
            });
            this.$Progress.start();
			this.can('finance_ledger_report').then(result => {
                this.finance_ledger_report = result.finance_ledger_report;
            }).then(result => {
                if(this.finance_ledger_report == true){
					this.getCompanies();
                    this.$Progress.finish();
                }else{
                    this.$Progress.finish();
                }
            });
        },
    }
</script>
